import { MembershipPlansProps } from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/actionType";
import { MembershipDurationsProps } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/actionType";

export enum actionTypes {
  //fetch COUPONS
  FETCH_COUPONS_REQUEST = "FETCH_COUPONS_REQUEST",
  FETCH_COUPONS_SUCCESS = "FETCH_COUPONS_SUCCESS",
  FETCH_COUPONS_FAIL = "FETCH_COUPONS_FAIL",
  //create coupon
  CREATE_COUPON_REQUEST = "CREATE_COUPON_REQUEST",
  CREATE_COUPON_SUCCESS = "CREATE_COUPON_SUCCESS",
  CREATE_COUPON_FAIL = "CREATE_COUPON_FAIL",
  //redeem coupon
  REDEEM_COUPON_REQUEST = "REDEEM_COUPON_REQUEST",
  REDEEM_COUPON_SUCCESS = "REDEEM_COUPON_SUCCESS",
  REDEEM_COUPON_FAIL = "REDEEM_COUPON_FAIL",
  RESET_COUPON = "RESET_COUPON",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface CouponProps {
  code: string;
  created_at: string;
  generationType: string;
  generation_type: string;
  id: string;
  membership_duration_id: string;
  redeemed: boolean;
  redeemed_at: string;
  updated_at: string;
  user_id: string;
}
export interface CouponDetailsProps {
  code: string;
  created_at: string;
  id: string;
  membership_durationId: string;
  package_name: string;
  receiver_detail: string;
}
export interface CouponCreatedProps {
  code: string;
  count: number;
  message: string;
  couponDetails: CouponDetailsProps[];
  couponDetail: CouponDetailsProps;
}
export interface RedeemCouponProps {
  membership_end_date: string;
  user_id: string;
  membership_duration_id: string;
  id: string;
  membership_join_date: string;
  membership_duration:MembershipDurationsProps
}
export interface CreateCouponInput {
  package_id?: string;
  membershipDurationID: string;
  receiverDetail?: string;
  generationType: string;
  count: number;
  userEmail?: string;
}
export interface RedeemCouponInput {
  coupon_code: string;
  user_id: string;
}

export interface CouponError {
  membershipDurationID?: string;
  receiverDetail?: string;
  generationType?: string;
  count?: string;
}

//fetch coupons
export interface FetchCouponsRequestAction {
  type: actionTypes.FETCH_COUPONS_REQUEST;
}

export interface FetchCouponsSuccessAction {
  type: actionTypes.FETCH_COUPONS_SUCCESS;
  payload: CouponProps[];
}

export interface FetchCouponsFailAction {
  type: actionTypes.FETCH_COUPONS_FAIL;
  payload: string;
}

//create coupon
export interface CreateCouponRequestAction {
  type: actionTypes.CREATE_COUPON_REQUEST;
}

export interface CreateCouponSuccessAction {
  type: actionTypes.CREATE_COUPON_SUCCESS;
  payload: CouponCreatedProps;
}

export interface CreateCouponFailAction {
  type: actionTypes.CREATE_COUPON_FAIL;
  payload: string;
}
export interface ResetCoupon {
  type: actionTypes.RESET_COUPON;
}
//redeem coupon
export interface RedeemCouponRequestAction {
  type: actionTypes.REDEEM_COUPON_REQUEST;
}

export interface RedeemCouponSuccessAction {
  type: actionTypes.REDEEM_COUPON_SUCCESS;
  payload: RedeemCouponProps;
}

export interface RedeemCouponFailAction {
  type: actionTypes.REDEEM_COUPON_FAIL;
  payload: string;
}
export interface ResetCoupon {
  type: actionTypes.RESET_COUPON;
}

export type CouponsActions =
  | FetchCouponsRequestAction
  | FetchCouponsSuccessAction
  | FetchCouponsFailAction
  | RedeemCouponRequestAction
  | RedeemCouponSuccessAction
  | RedeemCouponFailAction
  | CreateCouponRequestAction
  | CreateCouponSuccessAction
  | CreateCouponFailAction
  | ResetCoupon;
